// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"248":"94416742","337":"f14f0c89"}[chunkId] + ".chunk.css";
};